import { HtmlText } from '@Components/BigBrowse/GridCardMesh/Components/Texts/HtmlText';
import { convertToHtmlTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/texts.common';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { HeroAndTextMoreCta } from '@Components/BigBrowse/bb2/meshes2/heroAndText/Components/HeroAndTextMoreCta';
import { Box, Flex } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_HeroAndText_TextPart>;
};

export const TitleColumn = observer(function TitleColumn({ gridCard }: Props) {
  const { titleColumn, title, cta } = gridCard.data!.styles!.textPart!;

  const displayCta = cta?.position === 'moreCta_under_title';

  const props = convertToHtmlTextProps(title!.props);

  return (
    <Flex
      position={[titleColumn!.position.x, titleColumn!.position.y, 0]}
      size={[titleColumn!.size.width, titleColumn!.size.height, 0]}
      centerAnchor
      justifyContent='flex-start'
      alignItems='flex-start'
      flexDirection='column'
    >
      <Box width={title!.size.width} height={title!.size.height} centerAnchor>
        <HtmlText size={title!.size} {...props} />
      </Box>
      {displayCta && (
        <Flex
          centerAnchor
          size={[titleColumn!.size.width, cta!.size.height, 0]}
          marginTop={cta?.marginTop}
          alignItems='flex-start'
        >
          <HeroAndTextMoreCta gridCard={gridCard} />
        </Flex>
      )}
    </Flex>
  );
});
